export class GroupPaymentType {
    id?: number;
    title?: string;
    name?: string;

    static fromJson(fields: any): GroupPaymentType {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
